import {
    GET_REGION_STATE_REPORT_ERROR,
    GET_REGION_STATE_REPORT_REQUEST,
    GET_REGION_STATE_REPORT_SUCCESS,
} from "./types";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

const axios = require("axios");
export const getOmsRegionStateReport = (token, data) => (dispatch) => {
    dispatch({ type: GET_REGION_STATE_REPORT_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/getSaleOrderOmsCustomerByRegionStateReport`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            from_date: moment(data.from_date).format("MM-DD-YYYY"),
            to_date: moment(data.to_date).format("MM-DD-YYYY"),
            gender_id: data.gender_id === "All" ? null : data.gender_id,
            customer_type_id: data.customer_type_id === "All" ? null : data.customer_type_id,
            date_type: data.date_type,
            region_id: data.selected_id,
            company_id: data.company_id === "All" ? null : Number(data.company_id),
            state_id: data.select === "true" ? null : data.state_id
        }
    })
        .then((response) => {
            return dispatch({ type: GET_REGION_STATE_REPORT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_REGION_STATE_REPORT_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_REGION_STATE_REPORT_ERROR,
                payload: error.response,
            });
        });
};
